import { CHORD_PAIRS } from '@tunasong/music-lib'
import type { VoiceLeadingSessionStats } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './voice-leading-lab-summary.module.css'

export interface VoiceLeadingLabSummaryProps {
  stats: VoiceLeadingSessionStats
  onRestart: () => void
  onSwitchToExplore: () => void
}

/**
 * Voice-Leading Quiz session summary. Overall score + per-pair breakdown (rows
 * only for pairs that were actually asked) + Restart / Switch-to-Explore.
 *
 * Spec: docs/superpowers/specs/2026-05-27-voice-leading-lab-v1-design.md §5
 */
export const VoiceLeadingLabSummary: FC<VoiceLeadingLabSummaryProps> = props => {
  const { stats, onRestart, onSwitchToExplore } = props
  const askedPairs = CHORD_PAIRS.filter(pair => stats.byPair[pair].total > 0)

  return (
    <section className={styles.panel} aria-label="Voice-Leading Quiz summary">
      <p className={styles.scoreLine}>
        You got{' '}
        <strong>
          {stats.correct} / {stats.total} correct
        </strong>
      </p>

      <dl className={styles.breakdown}>
        {askedPairs.map(pair => (
          <div key={pair} className={styles.pairRow} data-testid="vl-summary-pair-row">
            <dt>{pair}</dt>
            <dd>
              {stats.byPair[pair].correct} / {stats.byPair[pair].total}
            </dd>
          </div>
        ))}
      </dl>

      <div className={styles.actions}>
        <Button type="button" variant="contained" onClick={onRestart}>
          Restart
        </Button>
        <Button type="button" variant="outlined" onClick={onSwitchToExplore}>
          Switch to Explore
        </Button>
      </div>
    </section>
  )
}
